var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sweet-modal",
    { ref: "modal", attrs: { "overlay-theme": "dark" } },
    [
      _vm.currentStep === 1
        ? _c("section", { staticClass: "text-left" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _vm.imageUrl
                  ? _c("div", { staticClass: "mb-4 text-center" }, [
                      _c("img", {
                        staticClass: "img-fluid",
                        attrs: { src: _vm.imageUrl, alt: "" }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("h3", { staticClass: "text-center" }, [
                  _vm._v(_vm._s(_vm.title))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-center pb-3" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.description) + "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card bg-light" }, [
                  _c("div", { staticClass: "card-body text-center" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("message.my_reservations.cancel_message")
                        ) +
                        "\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-start"
                  },
                  [
                    _c("div", { staticClass: "flex-grow-1 pr-3" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-info btn-block",
                          attrs: {
                            href: "https://line.me/R/ti/p/%40hnk7011n",
                            target: "_blank"
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("message.button.contact_admin")) +
                              "\n            "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://line.me/R/ti/p/%40hnk7011n",
                            target: "_blank"
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "img-fluid",
                            attrs: {
                              src: "/static/img/ic_operator.png",
                              alt: ""
                            }
                          })
                        ]
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 mt-3" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-link btn-block text-info",
                    attrs: { disabled: _vm.isLoading },
                    on: {
                      click: function($event) {
                        return _vm.checkNextStep()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.isLoading
                            ? _vm.$t("message.button.loading")
                            : _vm.$t("message.button.confirm_cancel_booking")
                        ) +
                        "\n        "
                    )
                  ]
                )
              ])
            ])
          ])
        : _vm.currentStep === 2
        ? _c("section", { staticClass: "text-left" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h3", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("message.my_reservations.cancel_dialog_question")
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "pl-3" },
                    [
                      _vm._l(_vm.cancelTypes, function(cancelType) {
                        return [
                          _c(
                            "b-form-radio",
                            {
                              staticClass: "p-2",
                              attrs: { name: "some-radios", value: cancelType },
                              model: {
                                value: _vm.selectedCancelType,
                                callback: function($$v) {
                                  _vm.selectedCancelType = $$v
                                },
                                expression: "selectedCancelType"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm._f("multiLangName")(cancelType)) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.selectedCancelType && _vm.selectedCancelType.id === 1
                ? _c("div", { staticClass: "col-12 mb-4" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.remark,
                          expression: "remark"
                        }
                      ],
                      staticClass: "form-control",
                      class: { "form-alert": _vm.errorMessage },
                      attrs: {
                        rows: "2",
                        placeholder: _vm.$t(
                          "message.my_reservations.cancel_remark"
                        )
                      },
                      domProps: { value: _vm.remark },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.remark = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.errorMessage && !_vm.remark
                      ? _c(
                          "div",
                          { staticClass: "text-danger text-remark pt-2" },
                          [_vm._v(_vm._s(_vm.errorMessage))]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedCancelType &&
              _vm.selectedCancelType.allow_contact === 1
                ? _c("div", { staticClass: "col-12 pb-4" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-outline-info btn-block",
                        attrs: {
                          href: "https://line.me/R/ti/p/%40hnk7011n",
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("message.button.contact_admin")) +
                            "\n        "
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-info btn-block",
                    on: {
                      click: function($event) {
                        return _vm.closeModal()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("message.button.close")) +
                        "\n        "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              !_vm.selectedCancelType ||
              (_vm.selectedCancelType &&
                _vm.selectedCancelType.allow_contact === 0)
                ? _c("div", { staticClass: "col" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-info btn-block",
                        on: {
                          click: function($event) {
                            return _vm.cancelOrder()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("message.button.confirm")) +
                            "\n        "
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6da65f1e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6da65f1e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/components/CancelOrderModal.vue
// module id = 1645
// module chunks = 0